/* AUGE – Header inline menu (desktop) – versão otimizada (idempotente, observer leve) */
(function () {
  // Fallback imediato
  const STATIC_FALLBACK = [
    { title: 'NEW IN',     url: '/collections/novidades' },
    { title: 'INSPIRAÇÃO', url: '/blogs/blog-gato-preto' },
    { title: 'PROMOÇÕES',  url: '/collections/promocoes' },
    { title: 'LOJAS',      url: '/pages/lojas-gato-preto' }
  ];
  const MENU_HANDLE = 'header-menu';
  const DESKTOP = window.matchMedia('(min-width: 750px)');
  const HEADER_ID = 'header-component';
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  // Estado
  let cacheItems = null;         // itens já obtidos (traduções ou fallback)
  let fetchedOnce = false;       // fetch só 1x
  let mounting = false;          // evita reentrâncias
  let mo = null;                 // MutationObserver
  let rafId = null;              // debounce via rAF

  // Util
  const sameList = (a, b) => {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i].title !== b[i].title || a[i].url !== b[i].url) return false;
    }
    return true;
  };

  function buildNav(items){
    const nav = document.createElement('nav');
    nav.className = 'header-inline-menu';
    nav.setAttribute('aria-label', 'Header inline menu');
    const ul = document.createElement('ul');
    ul.className = 'header-inline-menu__list';
    (items || []).forEach(it=>{
      if(!it || !it.title || !it.url) return;
      const li = document.createElement('li');
      li.className = 'header-inline-menu__item';
      const a = document.createElement('a');
      a.className = 'header-inline-menu__link';
      a.href = it.url;
      a.textContent = it.title;
      li.appendChild(a);
      ul.appendChild(li);
    });
    nav.appendChild(ul);
    return nav;
  }

  function headerEl(){ return document.getElementById(HEADER_ID); }
  function rightCol(scope){
    return scope.querySelector('.header__column--right') || scope.querySelector('.header__columns');
  }
  function findLocalization(scope){
    return (
      scope.querySelector('dropdown-localization-component') ||
      scope.querySelector('.localization-wrapper') ||
      scope.querySelector('.localization') ||
      scope.querySelector('localization-form') ||
      scope.querySelector('[data-localization-form]') ||
      scope.querySelector('form[action*="locale"]')
    );
  }
  function findActions(scope){
    return (
      scope.querySelector('header-actions') ||
      scope.querySelector('.header-actions') ||
      scope.querySelector('header-actions-component')
    );
  }

  function placeNav(right, nav){
    const before = findLocalization(right) || findActions(right);
    if (before) {
      if (nav.nextSibling !== before) right.insertBefore(nav, before);
    } else if (nav.parentNode !== right) {
      right.appendChild(nav);
    }
  }

  function render(items){
    const hdr = headerEl(); if (!hdr) return;
    const right = rightCol(hdr); if (!right) return;

    // existe?
    let nav = right.querySelector('.header-inline-menu');
    if (!nav) {
      nav = buildNav(items);
      right.appendChild(nav);
    } else {
      // só atualiza se mudou
      const temp = buildNav(items);
      if (nav.innerHTML !== temp.innerHTML) nav.innerHTML = temp.innerHTML;
    }
    placeNav(right, nav);
  }

  async function fetchTranslations(){
    if (fetchedOnce) return null;
    fetchedOnce = true;
    try {
      const ctl = new AbortController();
      const t = setTimeout(()=>ctl.abort(), 3000); // timeout 3s
      const res = await fetch(`${ROOT}menus/${MENU_HANDLE}.json`, { credentials:'same-origin', signal: ctl.signal });
      clearTimeout(t);
      if (!res.ok) return null;
      const data = await res.json();
      const items = (data && data.menu && Array.isArray(data.menu.items) && data.menu.items) || [];
      const normalized = items.map(i => ({ title: i.title, url: i.url })).filter(i => i.title && i.url);
      return normalized.length ? normalized : null;
    } catch (_) {
      return null;
    }
  }

  function injectNow(){
    if (!DESKTOP.matches || mounting) return;
    mounting = true;

    // primeiro: fallback (garante UI imediata)
    if (!cacheItems) {
      cacheItems = STATIC_FALLBACK;
      render(cacheItems);
    } else {
      render(cacheItems);
    }

    // depois: upgrade (uma única vez)
    if (!fetchedOnce) {
      fetchTranslations().then(items => {
        if (items && !sameList(items, cacheItems)) {
          cacheItems = items;
          render(cacheItems);
        }
      }).finally(()=>{ mounting = false; });
    } else {
      mounting = false;
    }
  }

  function debouncedInject(){
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(injectNow);
  }

  function mount(){
    // monta quando o DOM estiver pronto/visível
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', debouncedInject, { once:true });
    } else {
      debouncedInject();
    }

    // observar **apenas** o header (não o body inteiro)
    const hdr = headerEl();
    if (hdr && !mo) {
      mo = new MutationObserver(()=>debouncedInject());
      mo.observe(hdr, { childList:true, subtree:true });
    }

    // alternância mobile/desktop
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', debouncedInject);
    else DESKTOP.onchange = debouncedInject;
  }

  mount();
})();
